/* R44 Pay Day - copy code + countdown */
(function () {
  var b = document.getElementById('pd-copy');
  if (b) {
    var dt = b.querySelector('.pd-code__bt').textContent;
    b.addEventListener('click', function () {
      var code = b.getAttribute('data-code') || '';
      var done = function () {
        b.classList.add('copied');
        b.querySelector('.pd-code__bt').textContent = 'Copied!';
        setTimeout(function () { b.classList.remove('copied'); b.querySelector('.pd-code__bt').textContent = dt; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(done).catch(function () { fb(code, done); }); } else { fb(code, done); }
    });
  }
  function fb(t, cb) { var a = document.createElement('textarea'); a.value = t; a.setAttribute('readonly', ''); a.style.position = 'absolute'; a.style.left = '-9999px'; document.body.appendChild(a); a.select(); try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(a); if (cb) cb(); }

  var cd = document.getElementById('pd-cd');
  if (cd) {
    var end = new Date(cd.getAttribute('data-end')).getTime();
    var dd = cd.querySelector('[data-days]'), hh = cd.querySelector('[data-hours]'), mm = cd.querySelector('[data-mins]'), ss = cd.querySelector('[data-secs]');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var timer;
    var tick = function () {
      var diff = end - new Date().getTime();
      if (isNaN(end)) { return; }
      if (diff <= 0) { cd.classList.add('expired'); if (timer) clearInterval(timer); return; }
      var d = Math.floor(diff / 86400000), h = Math.floor((diff % 86400000) / 3600000), m = Math.floor((diff % 3600000) / 60000), s = Math.floor((diff % 60000) / 1000);
      if (dd) dd.textContent = pad(d); if (hh) hh.textContent = pad(h); if (mm) mm.textContent = pad(m); if (ss) ss.textContent = pad(s);
    };
    timer = setInterval(tick, 1000); tick();
  }
})();
